import * as billingSystem from './store'

export function billingSystemModule({ store }) {
  store.registerModule('billingSystem', { ...billingSystem, namespaced: true })
}
